import { supabase } from '@/integrations/supabase/client';
import { trackEvent } from './analytics';

// Session-level dedup to prevent repeat tracking on re-renders
const trackedEvents = new Set<string>();

function dedupKey(eventType: string, id?: string): string {
  return `${eventType}:${id || 'none'}`;
}

/**
 * Track a workshop analytics event. Fire-and-forget — never blocks the UI.
 * Deduplicates within the same browser session to avoid inflating counts.
 */
export function trackWorkshopEvent(
  eventType: string,
  options: {
    workshopId?: string;
    leaderId?: string;
    source?: string;
    metadata?: Record<string, unknown>;
    allowDuplicate?: boolean;
  } = {}
) {
  const { workshopId, leaderId, source, metadata, allowDuplicate = false } = options;

  // Dedup by event type + primary ID within this session
  const key = dedupKey(eventType, workshopId || leaderId);
  if (!allowDuplicate && trackedEvents.has(key)) return;
  trackedEvents.add(key);

  // Fire-and-forget insert to Supabase
  supabase
    .from('workshop_events')
    .insert({
      event_type: eventType,
      workshop_id: workshopId || null,
      leader_id: leaderId || null,
      source: source || null,
      metadata: metadata || {},
    })
    .then(() => {}, () => {}); // swallow errors silently

  // Also fire GA event
  trackEvent(`workshop_${eventType}`, {
    workshop_id: workshopId,
    leader_id: leaderId,
    source,
  });
}
